import type { Nullable } from "../../../../typescript"
import eightDirectionCharsLowerCase from "../../direction/eightDirectionCharsLowerCase"
import type { TileGraphNode } from "./TileGraphNode.type"

export default function getEightTilePositionNeighborsList(
  node: TileGraphNode): Array<Nullable<TileGraphNode>> {
  return eightDirectionCharsLowerCase.map(dir => node[dir])
}